import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import PublishIcon from "@material-ui/icons/Publish";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import Loads from "../../components/loading/load";
import { DropzoneDialog } from "material-ui-dropzone";

import "../../css/submissionFields.css";

import { useI18n } from "../../I18nProvider";

export default function LineSheet(props) {
  const appText = useI18n();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (value) => {
    setIsOpen(value);
  };

  return (
    <Grid
      item={true}
      xs={12}
      style={{
        align: "center",
      }}
    >
      <div id="desing-file">
        <Button
          variant="outlined"
          onClick={() => handleOpen(true)}
          disabled={props.isUploading}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              padding: 2.5,
            }}
          >
            <PublishIcon />
            {/* Upload Line Sheet */}
            {appText.T67}
          </div>
        </Button>

        <div id="header-upload-line-sheet">
          {/* <h8>For Apparel and Accessories Only</h8> */}
          <h8>{appText.T68}</h8>
        </div>

        <Grid xs={3} item={true}>
          <Loads hidden={!props.isUploading}></Loads>
          <DropzoneDialog
            open={isOpen}
            onSave={(files) => {
              props.handleSave("lineSheetFiles", files);
              handleOpen(false);
            }}
            showPreviews={true}
            showFileNames={true}
            filesLimit={1}
            maxFileSize={5000000000}
            onClose={() => handleOpen(false)}
          />
          {Array.isArray(props.lineSheetFilesBatch)
            ? props.lineSheetFilesBatch.map((item, id) => {
                return (
                  <div
                    style={{ display: props.isUploading ? "none" : "flex" }}
                    key={id}
                    className="file-uploaded"
                  >
                    <span className="file-name">{item.name}</span>
                    <div className="check-circle-icon">
                      <Tooltip title={appText.T286}>
                        <CheckCircleIcon />
                      </Tooltip>
                    </div>
                    <div
                      className="trash-icon"
                      onClick={() =>
                        props.handleRemoveFile("lineSheetFiles", item)
                      }
                    >
                      <Tooltip title={appText.T287}>
                        <DeleteIcon />
                      </Tooltip>
                    </div>
                  </div>
                );
              })
            : null}
        </Grid>
      </div>
    </Grid>
  );
}
